// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerErro {
  min-height: 30px;
  display: flex;
  align-items: center;
  font-size: 15px;
  justify-content: left;
}

.iconErro {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.CloseIconErro {
    width: 15px;
    margin: 10px;
    cursor: pointer;
}

.StarContainer .errorAbs {
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/error/error.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".containerErro {\n  min-height: 30px;\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  justify-content: left;\n}\n\n.iconErro {\n  width: 20px;\n  height: 20px;\n  margin-left: 10px;\n}\n\n.CloseIconErro {\n    width: 15px;\n    margin: 10px;\n    cursor: pointer;\n}\n\n.StarContainer .errorAbs {\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
